import { render } from "./statisticalAnalysisTable.vue?vue&type=template&id=bef384a6&scoped=true"
import script from "./statisticalAnalysisTable.vue?vue&type=script&lang=js"
export * from "./statisticalAnalysisTable.vue?vue&type=script&lang=js"

import "./statisticalAnalysisTable.vue?vue&type=style&index=0&id=bef384a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef384a6"]])

export default __exports__